var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HOme"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Home_2",
    d: "M8.39413 19.0405V16.2293C8.39412 15.5143 8.97705 14.9333 9.69928 14.9285H12.3449C13.0705 14.9285 13.6588 15.5109 13.6588 16.2293V16.2293V19.0492C13.6587 19.6563 14.1481 20.1524 14.7611 20.1667H16.5249C18.2831 20.1667 19.7084 18.7556 19.7084 17.015V17.015V9.01801C19.699 8.33326 19.3742 7.69024 18.8265 7.27195L12.7946 2.46152C11.7379 1.62393 10.2357 1.62393 9.17899 2.46152L3.17354 7.28068C2.62376 7.69727 2.29846 8.34136 2.29169 9.02674V17.015C2.29169 18.7556 3.71699 20.1667 5.47519 20.1667H7.2389C7.86718 20.1667 8.3765 19.6624 8.3765 19.0405V19.0405",
    stroke: "#161720",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a71b856c4bdd8091d33cbdc88b29ed25.svg";
export { ForwardRef as ReactComponent };